import script from "./AppPolityka.vue?vue&type=script&setup=true&lang=js"
export * from "./AppPolityka.vue?vue&type=script&setup=true&lang=js"

import "./AppPolityka.vue?vue&type=style&index=0&id=0e34c66c&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e34c66c"]])

export default __exports__